/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 14:08:11
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-20 18:12:02
 */
import { Col, Form, Input, Modal, Row, Select } from 'antd'
import { useDispatch } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { DurgSaveform } from '../commoditySave/Durgsaveform'
import { ApparatusSaveform } from '../commoditySave/ApparatusSaveform'
import { NondurgSaveform } from '../commoditySave/Nondurgsaveform'
import { MaterialSaveform } from '../commoditySave/Materialssaveform'
import { RootDispatch } from '../../app/store'
import styles from './Home.module.css'

const { Option } = Select

export const EditCatalogueModal = (props: {
  billingCategory?:any
  mappingId?: any
  hilistCode?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
  medicalType?: any
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  return (
    <Modal
      className={styles.modal}
      width={1850}
      title='编辑目录'
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      centered
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      {/* 1:药品 2:诊疗 3:耗材/材料	 */}
      {props?.medicalType == 1 ? (
        <DurgSaveform
          billingCategory={props?.billingCategory}
          hilistCode={props?.hilistCode}
          mappingId={props?.mappingId}
          materialCategory={0}
          flag={'/homeFlag'}
          refresh={() => {
            props?.onOk()
          }}
        ></DurgSaveform>
      ) : props?.medicalType == 3 ? (
        <MaterialSaveform
          billingCategory={props?.billingCategory}
          hilistCode={props?.hilistCode}
          mappingId={props?.mappingId}
          flag={'/homeFlag'}
          materialCategory={1}
          refresh={() => {
            props?.onOk()
          }}
        ></MaterialSaveform>
      ) : (
        <></>
      )}
    </Modal>
  )
}
